export default function Insta() {
  return <div>insta</div>;
}
